var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-counter"},[_vm._v(" "+_vm._s(_vm.computedCurrentPage)+" / "+_vm._s(_vm.totalPage)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }